@if (showSearchView && !showCreateView) {
  <lib-search-layout
    (createWorksite)="onCreateWorksite()"
    (createCompanyAndWorksite)="onCreateCompanyAndWorksite()"
    (selectWorksite)="onSelectWorksite($event)"
    [backToSearch]="backToSearch"
    [alreadySelectedWorksites]="alreadySelectedWorksites"
    [alreadySelectedFinanciers]="alreadySelectedFinanciers"
    [isFinancierSearch]="isFinancierSearch"
  ></lib-search-layout>
}
@if (showCreateView) {
  <lib-create-layout
    (navigateToSearch)="onNavigateToSearch()"
    (selectedWorksiteEmitter)="onSelectWorksite($event)"
  ></lib-create-layout>
}
